import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useOrgAdoption() {
  return useQuery({
    queryKey: ["platformAnalytics", "orgAdoption"],
    queryFn: () => api.getOrgAdoption(),
  });
}
